import { css } from "styled-components";
import { desktop } from "utils/styles";

export const registerButtonStyles = css`
  background-color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  width: 100%;

  > span {
    color: #fff;
  }
  padding: 16px;
  height: unset;
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.primaryHover} !important;
    border-color: ${({ theme }) => theme.colors.primaryHover} !important;
  }

  & span {
    margin-top: 16px;
  }

  ${desktop`
    width: 50%;
  `}
`;

export const homeLayoutContainerStyles = css`
  width: 100vw;
  height: 100vh;

  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  padding: 100px 40px 0;

  border-top: 15px solid ${({ theme }) => theme.colors.secondary};
`;
